var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAsterisk = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#C62032"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.434 6.667c.607 0 1.116.509 1.116 1.115v3.469l3.008-1.747c.509-.29 1.212-.121 1.503.412a1.083 1.083 0 0 1-.412 1.504l-2.983 1.746 2.983 1.723c.534.315.728.994.412 1.527-.29.534-.994.704-1.503.413l-3.008-1.747v3.469c0 .606-.51 1.116-1.116 1.116-.606 0-1.115-.51-1.115-1.116v-3.468l-2.983 1.746a1.139 1.139 0 0 1-1.528-.413 1.139 1.139 0 0 1 .412-1.527l3.007-1.723L7.22 11.42c-.534-.29-.703-.97-.412-1.504a1.139 1.139 0 0 1 1.528-.412l2.983 1.747V7.782c0-.606.51-1.115 1.115-1.115z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAsterisk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/asterisk.48845284.svg";
export { ForwardRef as ReactComponent };